import request from 'utils/request';

const PREFIX = '/api/finance/billing/operation/';
const COMPANY_INFO = '/api/common/company-info';

export const BillingOperationAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
};

export function getCommonCompanyInfoList() {
  return request({
    url: COMPANY_INFO,
    method: 'get',
  });
}
export function getBillingOperationList(data) {
  return request({
    url: BillingOperationAPI.LIST,
    method: 'post',
    data,
  });
}

export function addBillingOperation(data) {
  return request({
    url: BillingOperationAPI.ADD,
    method: 'post',
    data,
  });
}
